<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />
      </b-col>
      <!-- Content Right -->
      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
            @click="showFormModal(null)"
            class="px-3 text-capitalize"
            variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد SMS
        </b-button>
      </b-col>
    </b-row>
    <div v-if="sms_message">

      <b-card body-class="p-0" class="mt-1">
        <table-head
            ref="adminsTableHeadComponent"
            :items="tableHeadings"
            @sort="sort"
        />
        <b-row
            class="py-1 mx-1 border-bottom"
            v-for="admin in sms_message"
            :key="admin.id"
        >
          <b-col class="d-flex align-items-center pl-0" >
            <span v-if="admin.user_name" style="background-color: #035af8; color: #fff;padding: 4px 6px;border-radius: 4px">
               {{ admin.user_name }}
            </span>
            <span v-if="admin.user_name ===' '">
              ----------
            </span>

          </b-col>
          <b-col class="d-flex align-items-center pl-0">
               <span v-if="admin.mobile">
               {{ admin.mobile }}
            </span>
            <span v-else>
              ----------
            </span>
          </b-col>
          <b-col class="d-flex align-items-center pl-0">
               <span v-if="admin.family" style="background-color: #f608be; color: #fff;padding: 4px 6px;border-radius: 4px">
               {{ admin.family }}
            </span>
            <span v-else>
              ----------
            </span>
          </b-col>
          <b-col class="d-flex align-items-center pl-0">
               <span v-if="admin.mobile">
               {{ admin.mobile }}
            </span>
            <span v-else>
              ----------
            </span>
          </b-col>
          <b-col class="d-flex align-items-center" v-if="admin.message">
            {{ admin.message }}
          </b-col>
          <!--          <b-col class="d-flex align-items-center" v-if="admin.host_name">
                      {{ admin.host_name }}
                    </b-col>
                    <b-col class="d-flex align-items-center" v-if="admin.price">
                      <strong class="text-success">
                        {{ formatnumber(admin.price) }}
                      </strong>
                      تومان
                    </b-col>-->
          <b-col
              class="d-flex align-items-center flex-row-reverse"
              style="direction: ltr"
          >
            {{ new Date(admin.created_at).toLocaleString('fa-IR', { timeZone: 'Iran' })}}
          </b-col>
          <b-col class="d-flex align-items-center">
            ---------
            <!--            <b-button
                            @click="showConfirmModal(admin)"
                            variant="flat-danger"
                            class="font-weight-bolder"
                        >
                          <feather-icon icon="Trash2Icon" size="20" />
                        </b-button>-->
            <!--            <b-button
                            @click="showFormModal(admin)"
                            variant="flat-secondary"
                            class="font-weight-bolder"
                        >
                          <feather-icon icon="Edit2Icon" size="20" />
                        </b-button>-->
          </b-col>
        </b-row>
      </b-card>
      <pagination
          ref="adminsPaginationComponent"
          v-model="page"
          :paginationData="paginationData"
      />
    </div>
    <b-sidebar
        width="700px"
        v-model="formModal"
        right
        backdrop
        shadow
        bg-variant="white"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
                style="background-color: rgba(75, 75, 75, 0.12)"
                @click="formModal = false"
                variant="flat-dark"
                class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{ editMode ? "ویرایش SMS" : "ایجاد SMS" }}
            </h3>
          </div>
        </div>
      </template>
      <b-container class=" mb-3">
        <div>
          برای ارسال هر sms اگه کاربران را انتخاب کنید برای کاربران،اگه شخصی شماره را وارد کنید برای شخص، در صورتی که هر دو فیلد را وارد کنید برای هر دو شماره sms ارسال خواهد شد. !
        </div>
        <b-form-group class="mt-3">
          <label for="admin_user" class="text-capitalize"> انتخاب مهمان  (همه کاربران سایت شامل میزبان نیز میباشد) :</label>
          <!--          <div class="my-1">لطفا اگه مهمانی وجود ندارد آن را بعنوان کاربر ثبت کنید ( صبر کنید تا کاربران کامل لود شود)</div>-->
          <b-form-input v-if="editMode" disabled v-model="smsMessageInput.full_name"></b-form-input>
          <v-select
              v-if="!editMode"
              id="owner_user"
              :components="{ OpenIndicator }"
              class="bg-white"
              :clearable="false"
              v-model="smsMessageInput.user_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :get-option-label="(option) => option.full_name"
              :reduce="(user) => user.id"
              :options="users"

              placeholder="برای جستجو تایپ کنید"
          >
            <template #option="{ full_name, mobile }">
              {{ full_name }}
              <br />
              <cite>{{ mobile }}</cite>
            </template>
          </v-select>
        </b-form-group>

        <b-form-group>
          <label for="mobile" class="text-capitalize"
          > شماره شخصی (09015799400) <span class="text-danger">*</span></label
          >
          <b-form-input
              lazy
              v-model="smsMessageInput.mobile"
              id="mobile"
              key="mobile1"
              placeholder="09015799400"
          />
        </b-form-group>

        <b-form-group>
          <label for="family" class="text-capitalize"
          > نام خانوادگی شخص (اختیاری)  <span class="text-danger">*</span></label
          >
          <b-form-input
              lazy
              v-model="smsMessageInput.family"
              id="family"
              key="family1"
              placeholder=" نام خانوادگی"
          />
        </b-form-group>


        <b-form-group>
          <label for="address" class="text-capitalize"
          >متن پیام ( enter و space به هر تعداد در sms لحاظ خواهد شد ) :  <span class="text-danger">*</span></label
          >
          <b-form-textarea
              style="direction: rtl"
              rows="4"
              id="city_images"
              v-model="smsMessageInput.message"
              type="text"
          />
        </b-form-group>






        <b-button block class="float-center" v-if="editMode" @click="submitForm('changePermission')" variant="primary">
          ارسال sms
        </b-button>
      </b-container >
      <hr v-if="editMode" />
        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <b-button
              class="text-capitalize mr-2"
              @click="formModal = false"
              variant="outline-dark"
          >
            {{ $t("cancel") }}
          </b-button>
          <b-button variant="primary" @click="submitForm()">
            <div v-if="submitLoading" class="px-1">
              <b-spinner small style="width: 1.3rem; height: 1.3rem" />
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else class="text-capitalize">
              {{ $t("submit") }}
            </span>
          </b-button>
        </div>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormRadio,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";

export default {
  components: {
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    BFormRadio
  },
  data() {
    return {
      users: [],
      perPage: 10,
      page: 1,
      sms_message: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,
      tableHeadings: [
        {
          title: "نام کاربر",
          slug: "last_name",
          sortable: true,
        },
        {
          title: "شماره کاربر",
          slug: "mobile",
          sortable: true,
        },
        {
          title: "نام خانوادگی (مهمان)",
          slug: "mobile",
          sortable: true,
        },
        {
          title: "شماره مهمان",
          slug: "mobile",
          sortable: true,
        },

        {
          title: "متن",
          slug: "message",
          sortable: true,
        },
        {
          title: "تاریخ ارسال",
          slug: "created_at",
          sortable: true,
        },
        {
          title: "actions",
          sortable: false,
        },
      ],

      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },

      smsMessageInput: {
        id: "",
        user_id: "",
        mobile: "",
        message: "",
        family: "",
      },
      editMode: false,
      formModal: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getSmsMessage();
    this.getUsers();
    // this.getCompanies();
  },
  watch: {
    searchInput(value) {
      this.page = 1;
      this.getSmsMessage();
    },
    perPage(value) {
      this.page = 1;
      this.getSmsMessage();
    },
    page(value) {
      this.getSmsMessage();
    },
  },
  methods: {
    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getSmsMessage();
    },

    async getSmsMessage() {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        paginate:true,
        //  this.searchInput,
        // per_page: this.perPage,
        page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/sms_message",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.sms_message = data.data;
            this.paginationData = data.meta;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    showConfirmModal(smsMessage) {
      this.$bvModal
          .msgBoxConfirm(
              "آیا از حذف SMS مطمئن هستید ؟" +
              `: ${smsMessage.name}.`,
              {
                title: this.$t("Please Confirm"),
                size: "sm",
                okVariant: "primary",
                okTitle: this.$t("Yes"),
                cancelTitle: this.$t("No"),
                cancelVariant: "outline-secondary",
                hideHeaderClose: false,
                centered: true,
              }
          )
          .then(async (confirmed) => {
            if (confirmed) {
              let smsMessageIndex = 0;
              this.sms_message = await this.sms_message.filter((smsMessageItem, index) => {
                if (smsMessageItem.id == smsMessage.id) {
                  smsMessageIndex = index;
                }
                return smsMessageItem.id !== smsMessage.id;
              });

              const requestData = {
                method: "delete",
                url: `/admin/sms_message/${smsMessage.id}`,
              };
              this.$http(requestData)
                  .then((response) => {
                    this.$bvToast.toast(
                        `SMS: ${smsMessage.name} با موفقیت حذف شد.`,
                        {
                          title: this.$t("Done"),
                          variant: "success",
                          solid: true,
                        }
                    );
                  })
                  .catch((err) => {
                    let message = this.$t("Unable to delete!");
                    if (
                        err.response &&
                        err.response.data &&
                        err.response.data.message
                    )
                      message = err.response.data.message;
                    this.$bvToast.toast(message, {
                      title: this.$t("Error"),
                      variant: "danger",
                      solid: true,
                    });
                    this.sms_message.splice(smsMessageIndex, 0, smsMessage);
                  });
            }
          });
    },
    showFormModal(smsMessage) {
      if (smsMessage) {
        this.smsMessageInput = {
          id: smsMessage.id,
          user_id: smsMessage.user_id,
          mobile:smsMessage.mobile,
          family:smsMessage.family,
          message:smsMessage.message,
        };
        this.editMode = true;
      } else {
        this.smsMessageInput = {
          name: "",
          slug:"",
          status:"active",

        };
        this.editMode = false;
      }
      this.formModal = true;
    },
    submitForm() {
      if (this.submitLoading) return;
/*      let errorMessage = null;

      if (!errorMessage && !this.smsMessageInput.name) {
        errorMessage = "لطفا نام SMS را وارد کنید";
      }
      if (!errorMessage && this.smsMessageInput.name.length < 2) {
        errorMessage = "نام SMS نمی تواند کمتر از دو کاراکتر باشد";
      }
      if (!errorMessage && !this.smsMessageInput.slug) {
        errorMessage = "لطفا اسلاگ SMS را وارد کنید";
      }
      if (!errorMessage && this.smsMessageInput.slug.length < 2) {
        errorMessage = "اسلاگ SMS نمی تواند کمتر از دو کاراکتر باشد";
      }


      if (errorMessage) {
        this.$bvToast.toast(errorMessage, {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
        return;
      }*/

      this.submitLoading = true;

      const requestData = {
        method: this.editMode ? "put" : "post",
        url: this.editMode ? `/admin/sms_message/${this.smsMessageInput.id}` : `/admin/sms_message`,
        data: this.smsMessageInput,
      };

      this.$http(requestData)
          .then((response) => {
            let message = "SMS با موفقیت اضافه شد";
            if (this.editMode) message = "SMS با موفقیت ویرایش شد";
            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });
    /*        if (!this.editMode && this.sms_message && this.sms_message.length > 0) {
              this.$refs.sms_messagePaginationComponent.clear();
              // this.$refs.sms_messageSearchComponent.clear();
              this.$refs.sms_messageTableHeadComponent.clear();
              this.page = 1;
              this.searchInput = "";
              this.sortBy = "";
              this.sortDir = "";
            }*/

            this.submitLoading = false;
            this.formModal = false;
            this.getSmsMessage();
          })
        /*  .catch((err) => {
            let message = "خطا در ایجاد SMS";
            if (this.editMode) message = "خطا در ویرایش SMS";
            if (err.response && err.response.data && err.response.data.message)
              message = err.response.data.message;

            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });
            this.submitLoading = false;
            console.log(err);
          });*/
     /* this.submitLoading = false;
      this.formModal = false;
      this.getSmsMessage();*/
    },


    getUsers(search, loading) {
      if (typeof this.usersCancelToken != typeof undefined) {
        this.usersCancelToken.cancel(
            "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.usersCancelToken = this.$http.CancelToken.source();

      let data = {
        search: search,
        per_page: 10,
        page: 1,
      };

      const requestData = {
        method: "get",
        url: "/admin/users/get_total_users",
        params: data,
        // cancelToken: this.usersCancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.users = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },

  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
